<template>
  <div>
    <div v-if="isLoading">
      <v-progress-linear
        indeterminate
        color="primary"
        rounded
        height="5"
        class="mb-0"
      ></v-progress-linear>
    </div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-account </v-icon>
        <span class="pl-2">Account Information</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          Back
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
        <v-btn depressed color="primary" @click="editProfile" class="mx-1">
          Edit
          <v-icon right dark> mdi-pencil </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-5" v-if="user">
        <v-row>
          <v-col cols="12" md="3" v-if="user.avatar">
            <div class="d-flex justify-center">
              <avatar-image-component
                :edit="false"
                :avatarUrl="user.avatar"
                :user="user.id"
              ></avatar-image-component>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <v-row class="mx-2">
              <v-col cols="12" md="6">
                <p class="font-weight-bold">User Name</p>
                <div class="mt-4">
                  <p>{{ user.name }}</p>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <p class="font-weight-bold">Email</p>
                <div class="mt-4">
                  <p>{{ user.email }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-2">
              <v-col cols="12" md="6">
                <p class="font-weight-bold">Role</p>
                <div class="mt-4">
                  <v-chip color="primary" dark>
                    {{ getRoleValue(user.role_id) }}
                    <v-icon class="ml-2">
                      {{ getIconOfRole(user.role_id) }}
                    </v-icon>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <p class="font-weight-bold">Status</p>
                <div class="mt-4">
                  <v-chip :color="getStatusColor(user.status_id)" dark>
                    {{ getStatusValue(user.status_id) }}
                    <v-icon class="ml-2">
                      {{ getIconOfStatus(user.status_id) }}
                    </v-icon>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-2">
              <v-col cols="12" md="6">
                <p class="font-weight-bold">Phone Number</p>
                <div class="mt-4">
                  <p>{{ user.tel_number }}</p>
                </div>
              </v-col>
              <v-col v-if="userType === 'driver'" cols="12" md="6">
                <p class="font-weight-bold">Buses</p>
                <div class="mt-4">
                  <v-chip
                    color="success"
                    dark
                    v-for="bus in user.driver_buses"
                    :key="bus.id"
                    class="mx-1"
                  >
                    <div v-if="bus.name">
                      {{ bus.name }}
                    </div>
                    <div v-else>-</div>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AvatarImageComponent from '@/components/AvatarImageComponent.vue';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  components: { AvatarImageComponent },
  data() {
    return {
      isLoading: false,
      user_id: null,
      user: null,
      userType: null,
    };
  },
  mounted() {
    this.userType = this.$route.name.split('-').slice(-1)[0];
    console.log(this.userType);
    this.fetchProfile();
  },
  methods: {
    fetchProfile() {
      this.loading = true;
      axios
        .get(`/users/profile`)
        .then((response) => {
          this.user = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getStatusColor(status) {
      if (status == 1) {
        return 'success';
      } else if (status == 2) {
        return 'warning';
      } else if (status == 3) {
        return 'error';
      } else if (status == 4) {
        return 'info';
      }
    },
    getStatusValue(status) {
      if (status == 1) {
        return 'Active';
      } else if (status == 2) {
        return 'Pending';
      } else if (status == 3) {
        return 'Suspended';
      } else if (status == 4) {
        return 'Under Review';
      } else {
        return 'Unknown';
      }
    },
    getIconOfStatus(status) {
      if (status == 1) {
        return 'mdi-check-circle';
      } else if (status == 2) {
        return 'mdi-alert-circle';
      } else if (status == 3) {
        return 'mdi-close-circle';
      } else if (status == 4) {
        return 'mdi-information-outline';
      } else {
        return 'mdi-help-circle';
      }
    },
    getRoleValue(role) {
      if (role == 1) {
        return 'Admin';
      } else if (role == 2) {
        return 'Organisation';
      } else if (role == 3) {
        return 'Driver';
      } else if (role == 4) {
        return 'Parent';
      } else if (role == 5) {
        return 'Guardian';
      } else if (role == 6) {
        return 'Student';
      } else {
        return 'Unknown';
      }
    },
    getIconOfRole(role) {
      if (role == 1) {
        return 'mdi-account-lock';
      } else if (role == 2) {
        return 'mdi-domain';
      } else if (role == 3) {
        return 'mdi-account-tie-hat';
      } else if (role == 4) {
        return 'mdi-account-tie';
      } else if (role == 5) {
        return 'mdi-account-group';
      } else if (role == 6) {
        return 'mdi-badge-account-outline';
      } else {
        return 'mdi-account-question';
      }
    },
    editProfile() {
      this.$router.push({ name: 'edit-profile-' + this.userType });
    },
  },
};
</script>

<style lang="scss" scoped></style>
